import { useContext } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import {
  MdEventAvailable,
  MdLocationOn,
  MdArrowOutward,
  MdSchool,
} from "react-icons/md";

export default function OneEvent({ data, isHomeBadge = false }) {
  const appContext = useContext(AppContext);

  const tag =
    (data?.category || data?.type || data?.label || "Event").toString();
  const isTraining = tag.toLowerCase().includes("train");

  const primaryDate =
    data?.event_date || data?.eventDate || data?.startDate;

  function handleReadMore() {
    appContext.navTo({
      item: "view",
      subItem: "events",
      extraItem: data.uuid,
    });
  }

  const eventDate = primaryDate ? new Date(primaryDate) : null;
  const day = eventDate ? eventDate.getDate() : null;
  const month = eventDate
    ? eventDate.toLocaleString("default", { month: "short" })
    : null;

  return (
    <article
      className={`event-card h-100 ${isHomeBadge ? "event-card-compact" : ""}`}
      role="button"
      tabIndex={0}
      onClick={handleReadMore}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleReadMore();
      }}
    >
      <div
        className="event-hero"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.35), rgba(0,0,0,0.65)), url(${CDN_URL + data.photo})`,
        }}
      >
        <div className="event-tags">
          <span className={`event-chip ${isTraining ? "chip-training" : "muted"}`}>
            {isTraining ? <MdSchool className="me-1" /> : <MdEventAvailable className="me-1" />}
            {tag}
          </span>
        </div>
        {eventDate && (
          <div className="event-date">
            <div className="event-day">{day}</div>
            <div className="event-month">{month}</div>
          </div>
        )}
      </div>

      <div className="event-body">
        <h6 className="font-bold mb-2 event-title">{data.title}</h6>
        {data?.venue || data?.location ? (
          <div className="event-meta">
            <MdLocationOn size={16} className="text-secondary me-1" />
            <span>{data.venue || data.location}</span>
          </div>
        ) : null}
        <div className="d-flex align-items-center justify-content-between mt-3">
          <div className="event-time text-secondary">
            {eventDate
              ? eventDate.toLocaleString(undefined, {
                  weekday: "short",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "Date TBA"}
          </div>
          <button
            className="btn btn-link p-0 event-cta"
            onClick={(e) => {
              e.stopPropagation();
              handleReadMore();
            }}
          >
            View details <MdArrowOutward size={18} />
          </button>
        </div>
      </div>
    </article>
  );
}
